import {FC, useEffect, useState} from "react";
import {Flex, Radio, RadioGroupProps} from "antd";
import {EventsTable} from "../../components/EventsTable/EventsTable.tsx";
import {EventFilter} from "../../types/domain.ts";
import {useEvents} from "../../queries/useEvents.ts";
import {useOwnProfile} from "../../stores/OwnProfileStore.ts";
import {useNavigate} from "react-router";

export const InboxPage: FC = () => {
    const options: RadioGroupProps['options'] = [
        { label: 'Все', value: 'incoming' },
        { label: 'Согласование', value: 'incoming_approval' },
        { label: 'Возвращены', value: 'incoming_returned' }
    ]

    const [value, setValue] = useState<EventFilter>('incoming');
    const { data: events, isLoading, refetch } = useEvents(value);

    const { profile } = useOwnProfile();
    const navigate = useNavigate();
    useEffect(() => {
        if(profile?.role === 'fir_reader') navigate('/processing');
    }, [profile]);

    return (
        <Flex vertical gap={16} flex="1 0" style={{ width: '100%' }}>
            <Flex>
                <Radio.Group
                    block
                    options={options}
                    value={value}
                    onChange={(e) => setValue(e.target.value)}
                    optionType="button"
                    buttonStyle="solid"
                    size="large"
                />
            </Flex>
            <EventsTable
                events={events}
                loading={isLoading}
                onUpdate={refetch}
            />
        </Flex>
    );
}